import moment from 'moment';

const editAssignment = async ({ state, userId, updatingUser, job, jobElement, jobElementsWithDetails,
  costObject, groupsByBranchInCompany, service, assignmentServicesByGroup, generateItemDuration, updateState }) => {

  const { resource, itemDetails } = state;
  const tableDataSource = [];

  let selectedRowKey;
  /**
   * jobElementsWithDetails is an array of all of the jobElements associated with the job / request
   * that's associated with the job Element that's being edited here (or was at least was initally selected to edit)
   */
  let selectedJobElement = {}; // new
  let selectedJobElementFound = false;
  let jobElementArrLength = jobElementsWithDetails.length;
  for (let [idx, elem] of Object.entries(jobElementsWithDetails)) {
    let row = {
      key: jobElementArrLength > 1 && !selectedJobElementFound ? parseInt(idx) + 1 : parseInt(idx), // only shift those before selected
      id: elem.id,
      service: `${elem.serviceName} ${elem.packageName} ${elem.groupName}`,
      facility: elem.facilityName.replace('&nbsp', ""),
      resource: elem.resourceName.replace('&nbsp', ""),
      cost: `$${parseFloat(elem.activityCodePrice1).toFixed(2)}`
      // color: '#selectedRow'
    };

    // if jeId matches that of the jobElement just clicked on,
    // save the key bc that is the jobElement that will initially be on display when form opens up
    if ((jobElementArrLength > 1)
       && (elem.id == jobElement.id)
      ) {
      // selected Job Element (clicked on to open modal) will always be first element in table on form
      selectedJobElement = row; // save ref for later unshift after the loop
      selectedJobElement.key = 0;
      selectedRowKey = row.key
      selectedJobElementFound = true;
    } else {
      tableDataSource.push(row);
    }
  }

  // put selectedElement at the front of array; key = index = 0, so that its always on first page,
  // and you don't have to use pagination to get to it
  if (jobElementArrLength > 1) {
    tableDataSource.unshift(selectedJobElement);
  }

  /**
   * INSERT ASSIGNMENT / FORM DETAILS INTO ITEMDETAILS OBJECT FOR INITIAL FORM LOAD
   *
   */
  const { start_time, end_time, modalStartTime, modalEndTime } = itemDetails; // start-end time from timeline item
  itemDetails.initialSelectedRowKey = selectedRowKey;
  itemDetails.assignmentStartTime = modalStartTime ? moment(modalStartTime, 'MM-DD-YYYY h:mma') : start_time; // 7 & 9 day or 1 & 2 day
  itemDetails.assignmentEndTime = modalEndTime ? moment(modalEndTime, 'MM-DD-YYYY h:mma') : end_time;
  await generateItemDuration('assignment', itemDetails.assignmentStartTime, itemDetails.assignmentEndTime);

  await updateState({
    itemDetails,
    loading: false,
    tableDataSource,
    job,
    jobElement,
    jobElementsWithDetails,
    costObject,
    updatingUser,
    groupsByBranchInCompany, // dropdown list
    service, // dropdown list
    assignmentServicesByGroup // dropdown list
  });

}

export default editAssignment;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/loadItemData/editAssignment.js